import styled from 'styled-components';
import NativeLink from '../../../common/NativeLink';

const ModalTitle = styled.div`
  ${(props) => props.theme.font.heading.v100};
  font-weight: ${(props) => props.theme.font.weight.v300};
`;

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: space-around;
  padding: 30px 25px;
  background-color: ${(props) => props.theme.color.neutral.v100};
  text-align: center;
  font-size: 20px;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 35px 80px 60px;
  }
`;

const SadCarImage = styled.img`
  width: 56px;
  height: 56px;
`;

const IconImage = styled.div`
  width: 56px;
  height: 56px;
  margin: 0 0 15px;
`;

const ContentBody = styled.div`
  ${(props) => props.theme.font.body.v300};
  font-weight: ${(props) => props.theme.font.weight.v100};
  padding-top: 20px;
`;

const ModalMessage = styled.div`
  color: ${(props) => props.theme.color.neutral.v500};
  padding: 20px 0 30px 0;
  text-align: center;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  ${(props) => props.theme.font.body.v200};

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    ${(props) => props.theme.font.body.v300};
  }
`;

const SupportMessage = styled.div`
  color: ${(props) => props.theme.color.primary.v600};
  background-color: ${(props) => props.theme.color.neutral.v200};
  padding: 20px 40px;
  width: 100%;
  text-align: center;
  line-height: 28px;

  & b {
    display: block;
  }

  ${(props) => props.theme.font.body.v100};

  & a {
    color: ${(props) => props.theme.color.primary.v200};
    text-decoration: underline;
    &: hover {
      text-decoration: none;
    }
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    ${(props) => props.theme.font.body.v300};
    padding: 20px 0;
    & b {
      display: unset;
    }
    & span {
      display: block;
    }
  }
`;
const HyperLink = styled(NativeLink)`
  color: ${(props) => props.theme.color.primary.v200};
  text-decoration: underline;
`;
export {
  ModalTitle,
  ModalContent,
  ModalMessage,
  SupportMessage,
  SadCarImage,
  ContentBody,
  IconImage,
  HyperLink,
};
